import { Motion, spring } from 'react-motion'

import { getAbsoluteTopOfElement } from '/javascripts/utils/getAbsoluteTopOfElement'
import { MOTION_PRESETS } from '/react/constants/motionPresets'

import { withPageJump } from '/react/utils/withPageJump'

@withPageJump()

export class DeepLinkHandler extends Component {
  scrollOffset = 200

  state = {
    isInitialPageJump: false,
    isJumping: false,
    scrollTo: 0
  }

  springConfig = MOTION_PRESETS.SMOOTH

  getPageHash = () => window.location.hash

  handlePageInit = () => {
    const hash = this.getPageHash()
    const scrollY = window.pageYOffset

    if (hash) {
      window.addEventListener('load', () => this.handleHashChange({ isInitialPageJump: true }))
      return
    }

    if (scrollY > 0) {
      window.addEventListener('load', () => this.setPageJumpState({
        isInitialPageJump: true,
        isJumping: true,
        scrollTo: scrollY
      }))
    }
  }

  handleHashChange = ({ isInitialPageJump }) => {
    const hash = this.getPageHash()
    const targetElement = hash && document.querySelector(hash)

    if (!targetElement) return

    this.setPageJumpState({
      id: hash.substring(1),
      isInitialPageJump,
      isJumping: true,
      scrollTo: getAbsoluteTopOfElement(targetElement)
    })
  }

  handleScrollEnd = () => {
    this.setPageJumpState({
      isInitialPageJump: false,
      isJumping: false
    })
  }

  setPageJumpState = ({ id, isInitialPageJump, isJumping, scrollTo }) => {
    this.setState({
      isInitialPageJump,
      isJumping,
      scrollTo
    })

    this.props.setPageJump({
      pageHasJumpedToPosition: scrollTo,
      pageIsJumping: isJumping,
      pageJumpTargetId: id
    })
  }

  componentDidMount() {
    this.handlePageInit()
    window.addEventListener('hashchange', this.handleHashChange, false)
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange, false)
  }

  render () {
    const {
      isInitialPageJump,
      isJumping,
      scrollTo
    } = this.state

    const scrollStart = isInitialPageJump ? scrollTo - 1 : scrollTo - this.scrollOffset

    if (!isJumping) return null

    return (
      <Motion
        defaultStyle={{
          scrollTop: scrollStart
        }}
        style={{
          scrollTop: spring(scrollTo, this.springConfig)
        }}
        onRest={this.handleScrollEnd}
      >
        {(interpolatedStyle) => {
          window.scrollTo(0, interpolatedStyle.scrollTop)
          return null
        }}
      </Motion>
    )
  }
}
